module.exports = __webpack_public_path__ + "img/play_choosed.207d536b.png";